import { DownloadOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Image, notification, Row, Space, Tag } from 'antd';
import { format } from 'date-fns';
import React from 'react';
import { useParams } from 'react-router';
import { useDownloadCSV } from '../../../../utils/api/mpCatalogue/useDownloadCSV';
import { useGetMpCatalogueDetails } from '../../../../utils/api/mpCatalogue/useGetMpCatalogueDetails';
import {
  getStatusColor,
  getStatusLabel,
} from '../../../../utils/fn/mpProducts';
import ErrorPage from '../../../authentication/Error';
import LoadingComponent from '../../../loading/LoadingComponent';
import ProductDataDisplay from './ProductDataDisplay';

const MpProductDetails = () => {
  const params = useParams();
  const id = params.id;
  const {
    data: mpCatalogueDetails,
    isLoading,
    isError,
  } = useGetMpCatalogueDetails(id);
  const { downloadCSV, isLoading: isDownloadingCSV } = useDownloadCSV();

  if (isLoading) {
    return <LoadingComponent />;
  }
  if (isError) {
    return <ErrorPage />;
  }

  const handleExport = async () => {
    console.log('Export MP Product:', mpCatalogueDetails);
    const body = {
      products: [mpCatalogueDetails.product.reference],
      mp_category: mpCatalogueDetails.mp_category.id,
      store: mpCatalogueDetails.store.id,
    };
    try {
      const result = await downloadCSV(body);
      if (result.async) {
        notification.success({
          message: 'Export en cours',
          description: "Vous recevrez un email lorsque l'export sera terminé.",
          placement: 'bottomRight',
          duration: 5,
        });
      } else {
        notification.success({
          message: 'Export réussi',
          description: 'Le fichier a été exporté avec succès',
          placement: 'bottomRight',
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Erreur d'export",
        description: error.message,
        placement: 'bottomRight',
        duration: 3,
      });
    }
  };

  const handleBroadcast = () => {
    console.log('Broadcast MP Product:', id);
    // TODO: Implement broadcast functionality
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Row gutter={[4, 4]} style={{ flexShrink: 0 }}>
        <Col span={3}>
          <Image
            src={mpCatalogueDetails.product?.main_image}
            width={'95%'}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          />
        </Col>
        <Col span={21}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              {mpCatalogueDetails.mp_category?.name && (
                <Tag color="blue">{mpCatalogueDetails.mp_category.name}</Tag>
              )}
              {mpCatalogueDetails.store?.name && (
                <Tag color="green">{mpCatalogueDetails.store.name}</Tag>
              )}
            </div>
            <Space>
              <Button
                loading={isDownloadingCSV}
                type="default"
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                Exporter
              </Button>
              <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={handleBroadcast}
              >
                Diffuser
              </Button>
            </Space>
          </div>
          <h2>{mpCatalogueDetails.product?.name || 'Nom du produit'}</h2>
          <h3>{mpCatalogueDetails.product?.reference || 'Référence'}</h3>
          <Flex justify="space-between" align="center">
            <Space size={24}>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <span style={{ fontWeight: 500 }}>Statut </span>
                <Tag color={getStatusColor(mpCatalogueDetails.status)}>
                  {getStatusLabel(mpCatalogueDetails.status)}
                </Tag>
              </div>
              {mpCatalogueDetails.marketplace?.name && (
                <Tag color="purple">{mpCatalogueDetails.marketplace.name}</Tag>
              )}
            </Space>
            <Space>
              {mpCatalogueDetails.created_at && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Créé le </span>
                  <span>
                    {format(
                      new Date(mpCatalogueDetails.created_at),
                      'dd/MM/yyyy'
                    )}
                  </span>
                </div>
              )}
              {mpCatalogueDetails.updated_at && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Modifié le </span>
                  <span>
                    {format(
                      new Date(mpCatalogueDetails.updated_at),
                      'dd/MM/yyyy'
                    )}
                  </span>
                </div>
              )}
            </Space>
          </Flex>
        </Col>
      </Row>
      <Row
        gutter={[4, 4]}
        style={{ marginTop: 16, flex: 1, overflow: 'hidden' }}
      >
        <Col span={24} style={{ height: '100%' }}>
          <ProductDataDisplay
            productData={mpCatalogueDetails?.marketplace_product_data || []}
          />
        </Col>
      </Row>
    </div>
  );
};

export default MpProductDetails;
